import { render } from "./task-card.vue?vue&type=template&id=2501e287&scoped=true"
import script from "./task-card.vue?vue&type=script&lang=js"
export * from "./task-card.vue?vue&type=script&lang=js"

import "./task-card.vue?vue&type=style&index=0&id=2501e287&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2501e287"]])

export default __exports__